import React from 'react';

const PathPersonas = ({ personaData, formData }) => {
    if (!personaData || !personaData.personas) {
        return null; // Or return some fallback UI
    }

    return (
        <div className="space-y-4 px-4">
            {personaData.personas.map((persona, index) => (
                <div key={index} className="">
                    <div className="flex justify-between px-4 pb-4 rounded-lg bg-zinc-900/50 p-4">
                        <div className="flex-none w-3/12 items-start gap-6 print:gap-2 ">
                            {/* Persona Header Info */}
                            <div className="flex-grow ">
                                <div className="flex items-center gap-3">
                                    <div className="w-24 h-24 ml-2 mt-4 rounded-full bg-black/25 flex items-center aspect-square justify-center inline border-2 border-zinc-800"
                                        style={{
                                            backgroundImage: `url(/media/persona/${persona.image})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'top'
                                        }}
                                    />
                                    <div className='ml-2 flex flex-col justify-center'>
                                        <h4 className="text-zinc-50 text-lg ml-2">{persona.name}</h4>
                                        <div className="mt-2 text-sky-400 px-2 py-1 rounded-full w-full text-md font-medium">
                                            {persona.externalStakeholder === true ? (
                                                <span className="text-teal-400">
                                                    {persona.role}<br />
                                                    * customer of {formData.promptCustomerName}
                                                </span>
                                            ) : (
                                                <span>{persona.role}</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="flex-grow ml-4">
                            <div className="grid grid-cols-3 gap-0 text-base">
                                {/* Pain Points Section */}
                                <div className="border-rose-400/20 borxder bg-rosxxe-900/10 rounded p-4">
                                    <h5 className="text-rose-400 text-lg mb-3">Pain Points</h5>
                                    <ul className="list-disc pl-4 space-y-1 print:text-sm">
                                        {persona.painPoints && persona.painPoints.map((point, idx) => (
                                            <li key={idx} className="text-zinc-200">{point}</li>
                                        ))}
                                    </ul>
                                </div>

                                <div className="border-blue-400/20 borderdd bg-blxxue-900/10 rounded p-4">
                                    <h5 className="text-blue-400 text-lg mb-2">Goals</h5>
                                    <ul className="list-disc pl-4 space-y-1 print:text-sm">
                                        {persona.goals && persona.goals.map((goal, idx) => (
                                            <li key={idx} className="text-zinc-200">{goal}</li>
                                        ))}
                                    </ul>
                                </div>

                                {/* Success Metrics Section */}
                                <div className="border-green-400/20 borxder bg-gxxreen-900/10 rounded p-4">
                                    <h5 className="text-green-400 text-lg mb-3">Success Metrics</h5>
                                    <ul className="list-disc pl-4 space-y-1 print:text-sm">
                                        {persona.successMetrics && persona.successMetrics.map((metric, idx) => (
                                            <li key={idx} className="text-zinc-200">{metric}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Benefits Section */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        {persona.benefits && (
                            <>
                                {persona.benefits.strategic && (
                                    <div className="bg-black/20 rounded p-3">
                                        <h5 className="text-zinc-100 mb-2">Strategic Benefits</h5>
                                        <ul className="list-disc pl-4 space-y-1">
                                            {Array.isArray(persona.benefits.strategic) && persona.benefits.strategic.map((benefit, idx) => (
                                                <li key={idx} className="text-zinc-400">{benefit}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                {persona.benefits.financial && (
                                    <div className="bg-black/20 rounded p-3">
                                        <h5 className="text-zinc-100 mb-2">Financial Benefits</h5>
                                        <ul className="list-disc pl-4 space-y-1">
                                            {Array.isArray(persona.benefits.financial) && persona.benefits.financial.map((benefit, idx) => (
                                                <li key={idx} className="text-zinc-400">{benefit}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PathPersonas; 